import { createFeatureScope } from 'bundles/product-features';

export const { ProductFeaturesQuery, withProductFeatures, useProductFeatures } = createFeatureScope({
  enterprise: {
    skillsEnableForEnterpriseAdmins: false,
    enableAcademicDisciplines: false,
    enableEnhancedLearnerProfilesForAdmin: false,
    enableGwGForOrg: false,
    enableNewProgramCreation: false,
    enableXapiIntegration: false,
    enableSelfServiceSso: false,
    allowOrgForCurriculumBuilder: false,
    enableGwG: false,
    enableGwGFreemium: false,
    enableGwGPaid: false,
    enableC4CBFreemium: false,
    enableFreemium: false,
    isCareerAcademyLimitedCatalog: false,
    allowOrgForMoocFixedTerms: false,
    isCareerAcademySelfServeEnabled: false,
    allowOrgForSpecializationConfiguration: false,
    enableCareerAcademyLimitedRestrictions: false,
    enableGradebookPlagiarismReport: false,
    enableDataTechSku: false,
    enableAssignContent: false,
  },
});
